<template>
  <div class="event-detail" v-if="loaded == 200">
    <div class="content">
      <div class="event-detail__title" v-html="EventDetail.name"></div>
    </div>
    <Breadcrumbs
      :pages="[
        {
          name: 'Мероприятия',
          link: {
            name: 'Events',
          },
        },
        {
          name: EventDetail.name,
        },
      ]"
    />
    <div class="content">
      <div class="event-detail__banner">
        <img :src="EventDetail.banner" />
      </div>
      <div class="event-detail__info">
        <div v-if="is_start == 'not_started'" class="event-detail__join">
          <svg
            width="40"
            viewBox="0 0 50 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 4.4801C0 1.99596 1.97426 1.18322e-07 4.38386 1.18322e-07H45.6161C45.6167 1.18322e-07 45.6173 -1.47902e-07 45.6179 1.18322e-07C48.0293 0.000994199 50 1.99922 50 4.4801V31.5077C50 33.9918 48.0257 35.9878 45.6161 35.9878H26.4382V42.045H30.8905C31.6843 42.045 32.3297 42.6932 32.3297 43.5225C32.3297 44.3565 31.6797 45 30.8905 45H19.1094C18.3156 45 17.6703 44.3517 17.6703 43.5225C17.6703 42.6885 18.3202 42.045 19.1094 42.045H23.5618V35.9878H4.38386C1.97167 35.9878 0 33.9892 0 31.5077V4.4801ZM45.6161 1.45161H4.38386C2.73054 1.45161 1.40389 2.81723 1.40389 4.4801V31.5077C1.40389 33.169 2.72899 34.5362 4.38386 34.5362H24.9657V43.4966H19.1094C19.0975 43.4966 19.0904 43.4989 19.0866 43.5005C19.0826 43.5022 19.0801 43.5041 19.0787 43.5056C19.0773 43.507 19.0765 43.5083 19.076 43.5096C19.0756 43.5105 19.0742 43.5141 19.0742 43.5225C19.0742 43.5305 19.0756 43.5342 19.076 43.5353C19.0766 43.5368 19.0775 43.5382 19.0789 43.5396C19.0803 43.541 19.0826 43.5429 19.0865 43.5446C19.09 43.5461 19.0972 43.5484 19.1094 43.5484H30.8905C30.9025 43.5484 30.9096 43.5461 30.9133 43.5445C30.9174 43.5428 30.9198 43.5409 30.9213 43.5394C30.9227 43.538 30.9234 43.5367 30.924 43.5354C30.9243 43.5345 30.9258 43.5309 30.9258 43.5225C30.9258 43.5145 30.9244 43.5108 30.9239 43.5097C30.9233 43.5082 30.9225 43.5068 30.9211 43.5054C30.9197 43.504 30.9173 43.5021 30.9134 43.5004C30.9099 43.4989 30.9028 43.4966 30.8905 43.4966H25.0343V34.5362H45.6161C47.0152 34.5362 48.1804 33.5582 48.5056 32.2498L48.4372 32.2482C48.1155 33.5409 46.9707 34.4864 45.6158 34.4864L4.38391 34.4843C4.3839 34.4843 4.38392 34.4843 4.38391 34.4843C2.78416 34.4842 1.47238 33.1641 1.47238 31.5054L1.47445 4.47999C1.47445 4.47997 1.47445 4.48001 1.47445 4.47999C1.47448 2.82427 2.78331 1.50116 4.38598 1.50116H45.6179C47.2177 1.50116 48.5294 2.82126 48.5294 4.47999V32.1463C48.5731 31.9402 48.5961 31.7265 48.5961 31.5077V4.4801C48.5961 2.81881 47.271 1.45161 45.6161 1.45161ZM47.1255 30.7648V4.47999C47.1255 3.64288 46.4617 2.95278 45.6179 2.95278H4.38598C3.54095 2.95278 2.87834 3.64411 2.87834 4.47999L2.87627 31.5054C2.87627 31.5054 2.87627 31.5054 2.87627 31.5054C2.8763 32.3425 3.54011 33.0326 4.38391 33.0326L45.6158 33.0348C46.4609 33.0348 47.1235 32.3434 47.1235 31.5075V30.7648L47.1255 30.7648ZM8.83605 11.9867C8.83605 8.67704 11.4729 6.00532 14.6923 6.00532C17.9141 6.00532 20.5485 8.67953 20.5485 11.9867C20.5485 15.2965 17.9117 17.9682 14.6923 17.9682C11.4705 17.9682 8.83605 15.294 8.83605 11.9867ZM14.6923 7.45693C12.2293 7.45693 10.2399 9.49817 10.2399 11.9867C10.2399 14.4736 12.2276 16.5166 14.6923 16.5166C17.1553 16.5166 19.1446 14.4753 19.1446 11.9867C19.1446 9.4999 17.1569 7.45693 14.6923 7.45693ZM14.6923 8.95826C13.0374 8.95826 11.7123 10.3255 11.7123 11.9867C11.7123 13.6496 13.039 15.0152 14.6923 15.0152C16.3472 15.0152 17.6723 13.648 17.6723 11.9867C17.6723 10.3239 16.3456 8.95826 14.6923 8.95826ZM10.3084 11.9867C10.3084 9.50524 12.2801 7.50665 14.6923 7.50665C17.1019 7.50665 19.0761 9.50261 19.0761 11.9867C19.0761 14.4683 17.1045 16.4669 14.6923 16.4669C12.2827 16.4669 10.3084 14.4709 10.3084 11.9867ZM30.0896 9.28332C30.9974 8.75285 32.0841 8.75232 32.9908 9.28378L32.9922 9.28459L44.1923 15.8844L44.0896 15.9892C44.5704 16.5284 44.8435 17.2369 44.8435 17.994C44.8435 19.0669 44.2949 20.0425 43.384 20.5764L32.9839 26.7048C32.5453 26.9572 32.0451 27.0962 31.5388 27.0962C31.0446 27.0962 30.5561 26.98 30.0867 26.7007C29.1771 26.1665 28.6294 25.1916 28.6294 24.1195V11.8663C28.6294 10.7933 29.1787 9.81724 30.0896 9.28332ZM41.8875 16.1971L32.2984 10.5466C32.2981 10.5464 32.2978 10.5462 32.2975 10.546C31.8211 10.2672 31.2598 10.2669 30.7804 10.5471C30.3085 10.8241 30.0332 11.3179 30.0332 11.8663V24.1195C30.0332 24.6682 30.3088 25.1622 30.7812 25.4392L30.7857 25.4418C31.0239 25.5838 31.2676 25.6446 31.5388 25.6446C31.7976 25.6446 32.0625 25.573 32.2983 25.438C32.2992 25.4375 32.3002 25.4369 32.3011 25.4364L42.6903 19.3144L42.6916 19.3136C43.1641 19.0367 43.4396 18.5427 43.4396 17.994C43.4396 17.4453 43.1641 16.9512 42.6916 16.6743L41.8839 16.2008L41.8875 16.1971ZM31.5295 11.8433C31.5262 11.8449 31.5237 11.8463 31.5223 11.8471L31.5058 11.8569C31.5057 11.8589 31.5056 11.8613 31.5056 11.8641V24.1173C31.5056 24.1197 31.5057 24.1217 31.5057 24.1235C31.5317 24.1355 31.5412 24.1378 31.5473 24.1386L31.5509 24.1375C31.5538 24.1364 31.5592 24.1342 31.5672 24.1298C31.568 24.1293 31.5688 24.1288 31.5697 24.1283L41.6044 18.2152L41.6045 18.2091L41.9622 18.0023C41.9659 18.0001 41.9687 17.9983 41.9708 17.9969L41.9714 17.9918C41.9714 17.991 41.9715 17.9905 41.9715 17.9901C41.9715 17.9902 41.9715 17.9888 41.9714 17.9873L41.9708 17.9821C41.9692 17.9811 41.9673 17.9799 41.965 17.9786L41.9572 17.9742L31.569 11.8527C31.5683 11.8523 31.5675 11.8518 31.5668 11.8514C31.5554 11.8451 31.5457 11.8415 31.5389 11.8395C31.537 11.8401 31.535 11.8409 31.5329 11.8418C31.5318 11.8423 31.5307 11.8428 31.5295 11.8433ZM30.8377 10.5798C30.976 10.4998 31.2245 10.3866 31.5409 10.3866C31.7654 10.3866 32.0149 10.4484 32.25 10.5833L32.2571 10.5873L42.6446 16.7084C42.646 16.7092 42.6475 16.7101 42.6489 16.7109C43.3209 17.098 43.3754 17.7738 43.3754 17.9896C43.3754 18.1611 43.3411 18.6088 43.0055 18.9817L43.0052 19.0606L32.2493 25.3986C31.589 25.7763 31.0213 25.4943 30.8662 25.4166C30.6019 25.2842 30.1017 24.8814 30.1017 24.1173V11.8641C30.1017 11.116 30.5807 10.7202 30.8377 10.5798ZM5.89155 27.0015C5.89155 22.041 9.85124 18.0177 14.6923 18.0177H14.6945C19.5353 18.0177 23.4953 22.0407 23.4953 27.0015V28.5028C23.4953 29.3368 22.8453 29.9803 22.0561 29.9803H7.33069C6.53685 29.9803 5.89155 29.332 5.89155 28.5028V27.0015ZM14.6923 19.4693C10.6081 19.4693 7.29543 22.8617 7.29543 27.0015V28.5028C7.29543 28.5108 7.29682 28.5145 7.29727 28.5156C7.29787 28.5171 7.29874 28.5185 7.30014 28.5199C7.30154 28.5213 7.30389 28.5232 7.30776 28.5248C7.31129 28.5263 7.31841 28.5287 7.33069 28.5287H22.0561C22.0681 28.5287 22.0752 28.5264 22.0789 28.5248C22.083 28.5231 22.0854 28.5211 22.0869 28.5197C22.0883 28.5183 22.089 28.517 22.0896 28.5157C22.0899 28.5148 22.0914 28.5112 22.0914 28.5028V27.0015C22.0914 22.8615 18.7785 19.4693 14.6945 19.4693H14.6923ZM14.6923 20.9706C11.4178 20.9706 8.7676 23.6874 8.7676 27.0017V27.0276H20.617V27.0017C20.617 23.6874 17.9668 20.9706 14.6923 20.9706ZM7.36372 27.0017C7.36372 22.8666 10.661 19.519 14.6923 19.519C18.7236 19.519 22.0209 22.8666 22.0209 27.0017V28.4792H7.36372V27.0017Z"
              fill="white"
            />
          </svg>

          <div
            class="event-detail__join-button button button_white px-8"
            :style="subscribed ? 'pointer-events: none;' : ''"
            @click="subscribe"
          >
            {{ subscribed ? "Вы участвуете" : "Принять участие" }}
          </div>
        </div>
        <div
          class="event-detail__props"
          v-if="!subscribed && is_start == 'not_started'"
        >
          <div class="event-detail__prop">
            <div class="event-detail__prop-icon">
              <svg
                width="40"
                viewBox="0 0 50 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.3113 1.08736e-05C10.1182 0.000739944 9.92714 0.0382727 9.749 0.110466C9.57087 0.18266 9.40918 0.2881 9.27316 0.420767C9.13713 0.553433 9.02944 0.710728 8.95624 0.883671C8.88303 1.05661 8.84574 1.24182 8.8465 1.4287V3.90804H4.39453C1.91356 3.90804 0 6.00639 0 8.41647V36.665C0 39.0751 1.91354 41.1707 4.39453 41.1707H23.65C26.0985 45.2477 30.6574 48 35.8657 48C43.6499 48 50 41.8547 50 34.3218C50 29.7652 47.6766 25.7221 44.1176 23.237V8.41647C44.1176 6.00639 42.2012 3.90804 39.7202 3.90804H35.2683V1.4287C35.269 1.24181 35.2317 1.05661 35.1585 0.883667C35.0853 0.710724 34.9776 0.553428 34.8416 0.420761C34.7056 0.288094 34.5439 0.182655 34.3658 0.110462C34.1876 0.0382694 33.9965 0.000738042 33.8034 1.08736e-05C33.6093 -0.000723325 33.417 0.0357298 33.2375 0.107269C33.0581 0.178807 32.895 0.284016 32.7578 0.416829C32.6206 0.549642 32.5118 0.707432 32.4379 0.8811C32.364 1.05477 32.3263 1.24088 32.3271 1.4287V3.90804H11.7762V1.4287C11.7769 1.24181 11.7397 1.05661 11.6665 0.883667C11.5932 0.710724 11.4856 0.553428 11.3495 0.420761C11.2135 0.288094 11.0518 0.182655 10.8737 0.110462C10.6955 0.0382694 10.5045 0.000738042 10.3113 1.08736e-05ZM4.39453 6.75709H8.8465V9.22532C8.84574 9.41221 8.88303 9.59741 8.95624 9.77035C9.02944 9.94329 9.13713 10.1006 9.27316 10.2333C9.40918 10.3659 9.57087 10.4714 9.749 10.5436C9.92714 10.6158 10.1182 10.6533 10.3113 10.654C10.5045 10.6533 10.6955 10.6158 10.8737 10.5436C11.0518 10.4714 11.2135 10.3659 11.3495 10.2333C11.4856 10.1006 11.5932 9.9433 11.6665 9.77036C11.7397 9.59741 11.7769 9.41221 11.7762 9.22532V6.75709H32.3271V9.22532C32.3263 9.41314 32.364 9.59925 32.4379 9.77292C32.5118 9.94659 32.6206 10.1044 32.7578 10.2372C32.895 10.37 33.0581 10.4752 33.2375 10.5468C33.417 10.6183 33.6093 10.6547 33.8034 10.654C33.9965 10.6533 34.1876 10.6158 34.3658 10.5436C34.5439 10.4714 34.7056 10.3659 34.8416 10.2333C34.9776 10.1006 35.0853 9.9433 35.1585 9.77036C35.2317 9.59741 35.269 9.41221 35.2683 9.22532V6.75709H39.7202C40.4836 6.75709 41.1736 7.41028 41.1736 8.41647V13.856H2.94118V8.41647C2.94118 7.41028 3.63121 6.75709 4.39453 6.75709ZM2.94118 16.7051H41.1736V21.6582C39.5331 21.012 37.7416 20.6548 35.8657 20.6548C28.0815 20.6548 21.7429 26.789 21.7429 34.3218C21.7429 35.714 21.9612 37.0571 22.3633 38.3244H4.39453C3.63121 38.3244 2.94118 37.6712 2.94118 36.665V16.7051ZM35.8657 23.5011C38.0689 23.5011 40.1221 24.1125 41.8514 25.1688C41.8831 25.1904 41.9157 25.2108 41.9491 25.23C45.0274 27.1539 47.0588 30.4997 47.0588 34.3219C47.0588 40.3165 42.0604 45.1537 35.8657 45.1537C29.671 45.1537 24.684 40.3165 24.684 34.3219C24.684 28.3273 29.671 23.5011 35.8657 23.5011ZM35.0414 27.1034C34.6528 27.1048 34.2807 27.255 34.0062 27.5212C33.7318 27.7873 33.5773 28.1477 33.5765 28.5237V36.4343C33.5781 36.8098 33.7329 37.1695 34.0073 37.435C34.2816 37.7005 34.6533 37.8504 35.0414 37.8519H40.7744C40.9675 37.8526 41.1589 37.8165 41.3376 37.7457C41.5163 37.6748 41.6788 37.5706 41.8159 37.439C41.953 37.3073 42.0619 37.1509 42.1365 36.9785C42.2111 36.8061 42.2499 36.6212 42.2507 36.4343C42.2514 36.2465 42.2138 36.0604 42.1398 35.8867C42.0659 35.713 41.9572 35.5552 41.82 35.4224C41.6827 35.2896 41.5197 35.1844 41.3402 35.1129C41.1608 35.0413 40.9684 35.0049 40.7744 35.0056H36.5177V28.5237C36.5173 28.3366 36.4788 28.1514 36.4044 27.9787C36.3299 27.806 36.2211 27.6492 36.0839 27.5172C35.9468 27.3853 35.7841 27.2808 35.6052 27.2098C35.4263 27.1388 35.2347 27.1026 35.0414 27.1034Z"
                  fill="white"
                />
              </svg>
            </div>
            <div class="event-detail__prop-text">
              <div class="event-detail__prop-label">Дата и время</div>
              <div class="event-detail__prop-value">
                {{ date.getDate() }}
                {{ months[date.getMonth()] }}
                {{ date.getFullYear() }}, {{ date.getUTCHours() + 3 }}:{{
                  date.getMinutes().toString().padStart(2, 0)
                }}
                (Мск)
              </div>
            </div>
          </div>
          <div class="event-detail__prop" v-if="EventDetail.place">
            <div class="event-detail__prop-text">
              <div class="event-detail__prop-label">Место</div>
              <div class="event-detail__prop-value">
                {{ EventDetail.place }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="event-detail__timer"
          v-if="subscribed && is_start == 'not_started'"
        >
          <div class="event-detail__timer-title">
            <svg
              width="40"
              viewBox="0 0 50 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.3113 1.08736e-05C10.1182 0.000739944 9.92714 0.0382727 9.749 0.110466C9.57087 0.18266 9.40918 0.2881 9.27316 0.420767C9.13713 0.553433 9.02944 0.710728 8.95624 0.883671C8.88303 1.05661 8.84574 1.24182 8.8465 1.4287V3.90804H4.39453C1.91356 3.90804 0 6.00639 0 8.41647V36.665C0 39.0751 1.91354 41.1707 4.39453 41.1707H23.65C26.0985 45.2477 30.6574 48 35.8657 48C43.6499 48 50 41.8547 50 34.3218C50 29.7652 47.6766 25.7221 44.1176 23.237V8.41647C44.1176 6.00639 42.2012 3.90804 39.7202 3.90804H35.2683V1.4287C35.269 1.24181 35.2317 1.05661 35.1585 0.883667C35.0853 0.710724 34.9776 0.553428 34.8416 0.420761C34.7056 0.288094 34.5439 0.182655 34.3658 0.110462C34.1876 0.0382694 33.9965 0.000738042 33.8034 1.08736e-05C33.6093 -0.000723325 33.417 0.0357298 33.2375 0.107269C33.0581 0.178807 32.895 0.284016 32.7578 0.416829C32.6206 0.549642 32.5118 0.707432 32.4379 0.8811C32.364 1.05477 32.3263 1.24088 32.3271 1.4287V3.90804H11.7762V1.4287C11.7769 1.24181 11.7397 1.05661 11.6665 0.883667C11.5932 0.710724 11.4856 0.553428 11.3495 0.420761C11.2135 0.288094 11.0518 0.182655 10.8737 0.110462C10.6955 0.0382694 10.5045 0.000738042 10.3113 1.08736e-05ZM4.39453 6.75709H8.8465V9.22532C8.84574 9.41221 8.88303 9.59741 8.95624 9.77035C9.02944 9.94329 9.13713 10.1006 9.27316 10.2333C9.40918 10.3659 9.57087 10.4714 9.749 10.5436C9.92714 10.6158 10.1182 10.6533 10.3113 10.654C10.5045 10.6533 10.6955 10.6158 10.8737 10.5436C11.0518 10.4714 11.2135 10.3659 11.3495 10.2333C11.4856 10.1006 11.5932 9.9433 11.6665 9.77036C11.7397 9.59741 11.7769 9.41221 11.7762 9.22532V6.75709H32.3271V9.22532C32.3263 9.41314 32.364 9.59925 32.4379 9.77292C32.5118 9.94659 32.6206 10.1044 32.7578 10.2372C32.895 10.37 33.0581 10.4752 33.2375 10.5468C33.417 10.6183 33.6093 10.6547 33.8034 10.654C33.9965 10.6533 34.1876 10.6158 34.3658 10.5436C34.5439 10.4714 34.7056 10.3659 34.8416 10.2333C34.9776 10.1006 35.0853 9.9433 35.1585 9.77036C35.2317 9.59741 35.269 9.41221 35.2683 9.22532V6.75709H39.7202C40.4836 6.75709 41.1736 7.41028 41.1736 8.41647V13.856H2.94118V8.41647C2.94118 7.41028 3.63121 6.75709 4.39453 6.75709ZM2.94118 16.7051H41.1736V21.6582C39.5331 21.012 37.7416 20.6548 35.8657 20.6548C28.0815 20.6548 21.7429 26.789 21.7429 34.3218C21.7429 35.714 21.9612 37.0571 22.3633 38.3244H4.39453C3.63121 38.3244 2.94118 37.6712 2.94118 36.665V16.7051ZM35.8657 23.5011C38.0689 23.5011 40.1221 24.1125 41.8514 25.1688C41.8831 25.1904 41.9157 25.2108 41.9491 25.23C45.0274 27.1539 47.0588 30.4997 47.0588 34.3219C47.0588 40.3165 42.0604 45.1537 35.8657 45.1537C29.671 45.1537 24.684 40.3165 24.684 34.3219C24.684 28.3273 29.671 23.5011 35.8657 23.5011ZM35.0414 27.1034C34.6528 27.1048 34.2807 27.255 34.0062 27.5212C33.7318 27.7873 33.5773 28.1477 33.5765 28.5237V36.4343C33.5781 36.8098 33.7329 37.1695 34.0073 37.435C34.2816 37.7005 34.6533 37.8504 35.0414 37.8519H40.7744C40.9675 37.8526 41.1589 37.8165 41.3376 37.7457C41.5163 37.6748 41.6788 37.5706 41.8159 37.439C41.953 37.3073 42.0619 37.1509 42.1365 36.9785C42.2111 36.8061 42.2499 36.6212 42.2507 36.4343C42.2514 36.2465 42.2138 36.0604 42.1398 35.8867C42.0659 35.713 41.9572 35.5552 41.82 35.4224C41.6827 35.2896 41.5197 35.1844 41.3402 35.1129C41.1608 35.0413 40.9684 35.0049 40.7744 35.0056H36.5177V28.5237C36.5173 28.3366 36.4788 28.1514 36.4044 27.9787C36.3299 27.806 36.2211 27.6492 36.0839 27.5172C35.9468 27.3853 35.7841 27.2808 35.6052 27.2098C35.4263 27.1388 35.2347 27.1026 35.0414 27.1034Z"
                fill="white"
              />
            </svg>
            Мероприятие начнется через:
          </div>
          <div class="event-detail__timer-row">
            <div class="event-detail__timer-item" v-if="timerResult.days > 0">
              <div class="event-detail__timer-item-value">
                {{ timerResult.days }}
              </div>
              <div class="event-detail__timer-item-text">
                {{ helpers.getNoun(timerResult.days, "день", "дня", "дней") }}
              </div>
            </div>
            <div class="event-detail__timer-item" v-if="timerResult.hours > 0">
              <div class="event-detail__timer-item-value">
                {{ timerResult.hours }}
              </div>
              <div class="event-detail__timer-item-text">
                {{ helpers.getNoun(timerResult.hours, "час", "часа", "часов") }}
              </div>
            </div>
            <div
              class="event-detail__timer-item"
              v-if="timerResult.minutes > 0"
            >
              <div class="event-detail__timer-item-value">
                {{ timerResult.minutes }}
              </div>
              <div class="event-detail__timer-item-text">
                {{
                  helpers.getNoun(
                    timerResult.minutes,
                    "минуту",
                    "минуты",
                    "минут"
                  )
                }}
              </div>
            </div>
            <div
              class="event-detail__timer-item"
              v-if="timerResult.seconds > 0"
            >
              <div class="event-detail__timer-item-value">
                {{ timerResult.seconds }}
              </div>
              <div class="event-detail__timer-item-text">
                {{
                  helpers.getNoun(
                    timerResult.seconds,
                    "секунду",
                    "секунды",
                    "секунд"
                  )
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="event-detail__watch" v-if="is_start == 'started'">
          <div class="event-detail__watch-row">
            <div class="event-detail__watch-text">
              Мероприятие {{ EventDetail.integration ? "в эфире" : "началось" }}
              <div
                class="event-detail__watch-icon"
                v-if="EventDetail.integration"
              ></div>
            </div>
            <router-link
              v-if="EventDetail.integration"
              :to="{
                name: 'EventDetailLive',
                params: { id: $route.params.id, started: true },
                query: { ...$route.query },
              }"
              class="event-detail__watch-button button button_white px-8"
            >
              Смотреть
            </router-link>
          </div>
        </div>
        <div class="event-detail__finish" v-if="is_start == 'finished'">
          <div class="event-detail__finish-text">
            <div class="event-detail__finish-icon">
              <svg
                width="40"
                viewBox="0 0 50 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0 4.4801C0 1.99596 1.97426 1.18322e-07 4.38386 1.18322e-07H45.6161C45.6167 1.18322e-07 45.6173 -1.47902e-07 45.6179 1.18322e-07C48.0293 0.000994199 50 1.99922 50 4.4801V31.5077C50 33.9918 48.0257 35.9878 45.6161 35.9878H26.4382V42.045H30.8905C31.6843 42.045 32.3297 42.6932 32.3297 43.5225C32.3297 44.3565 31.6797 45 30.8905 45H19.1094C18.3156 45 17.6703 44.3517 17.6703 43.5225C17.6703 42.6885 18.3202 42.045 19.1094 42.045H23.5618V35.9878H4.38386C1.97167 35.9878 0 33.9892 0 31.5077V4.4801ZM45.6161 1.45161H4.38386C2.73054 1.45161 1.40389 2.81723 1.40389 4.4801V31.5077C1.40389 33.169 2.72899 34.5362 4.38386 34.5362H24.9657V43.4966H19.1094C19.0975 43.4966 19.0904 43.4989 19.0866 43.5005C19.0826 43.5022 19.0801 43.5041 19.0787 43.5056C19.0773 43.507 19.0765 43.5083 19.076 43.5096C19.0756 43.5105 19.0742 43.5141 19.0742 43.5225C19.0742 43.5305 19.0756 43.5342 19.076 43.5353C19.0766 43.5368 19.0775 43.5382 19.0789 43.5396C19.0803 43.541 19.0826 43.5429 19.0865 43.5446C19.09 43.5461 19.0972 43.5484 19.1094 43.5484H30.8905C30.9025 43.5484 30.9096 43.5461 30.9133 43.5445C30.9174 43.5428 30.9198 43.5409 30.9213 43.5394C30.9227 43.538 30.9234 43.5367 30.924 43.5354C30.9243 43.5345 30.9258 43.5309 30.9258 43.5225C30.9258 43.5145 30.9244 43.5108 30.9239 43.5097C30.9233 43.5082 30.9225 43.5068 30.9211 43.5054C30.9197 43.504 30.9173 43.5021 30.9134 43.5004C30.9099 43.4989 30.9028 43.4966 30.8905 43.4966H25.0343V34.5362H45.6161C47.0152 34.5362 48.1804 33.5582 48.5056 32.2498L48.4372 32.2482C48.1155 33.5409 46.9707 34.4864 45.6158 34.4864L4.38391 34.4843C4.3839 34.4843 4.38392 34.4843 4.38391 34.4843C2.78416 34.4842 1.47238 33.1641 1.47238 31.5054L1.47445 4.47999C1.47445 4.47997 1.47445 4.48001 1.47445 4.47999C1.47448 2.82427 2.78331 1.50116 4.38598 1.50116H45.6179C47.2177 1.50116 48.5294 2.82126 48.5294 4.47999V32.1463C48.5731 31.9402 48.5961 31.7265 48.5961 31.5077V4.4801C48.5961 2.81881 47.271 1.45161 45.6161 1.45161ZM47.1255 30.7648V4.47999C47.1255 3.64288 46.4617 2.95278 45.6179 2.95278H4.38598C3.54095 2.95278 2.87834 3.64411 2.87834 4.47999L2.87627 31.5054C2.87627 31.5054 2.87627 31.5054 2.87627 31.5054C2.8763 32.3425 3.54011 33.0326 4.38391 33.0326L45.6158 33.0348C46.4609 33.0348 47.1235 32.3434 47.1235 31.5075V30.7648L47.1255 30.7648ZM8.83605 11.9867C8.83605 8.67704 11.4729 6.00532 14.6923 6.00532C17.9141 6.00532 20.5485 8.67953 20.5485 11.9867C20.5485 15.2965 17.9117 17.9682 14.6923 17.9682C11.4705 17.9682 8.83605 15.294 8.83605 11.9867ZM14.6923 7.45693C12.2293 7.45693 10.2399 9.49817 10.2399 11.9867C10.2399 14.4736 12.2276 16.5166 14.6923 16.5166C17.1553 16.5166 19.1446 14.4753 19.1446 11.9867C19.1446 9.4999 17.1569 7.45693 14.6923 7.45693ZM14.6923 8.95826C13.0374 8.95826 11.7123 10.3255 11.7123 11.9867C11.7123 13.6496 13.039 15.0152 14.6923 15.0152C16.3472 15.0152 17.6723 13.648 17.6723 11.9867C17.6723 10.3239 16.3456 8.95826 14.6923 8.95826ZM10.3084 11.9867C10.3084 9.50524 12.2801 7.50665 14.6923 7.50665C17.1019 7.50665 19.0761 9.50261 19.0761 11.9867C19.0761 14.4683 17.1045 16.4669 14.6923 16.4669C12.2827 16.4669 10.3084 14.4709 10.3084 11.9867ZM30.0896 9.28332C30.9974 8.75285 32.0841 8.75232 32.9908 9.28378L32.9922 9.28459L44.1923 15.8844L44.0896 15.9892C44.5704 16.5284 44.8435 17.2369 44.8435 17.994C44.8435 19.0669 44.2949 20.0425 43.384 20.5764L32.9839 26.7048C32.5453 26.9572 32.0451 27.0962 31.5388 27.0962C31.0446 27.0962 30.5561 26.98 30.0867 26.7007C29.1771 26.1665 28.6294 25.1916 28.6294 24.1195V11.8663C28.6294 10.7933 29.1787 9.81724 30.0896 9.28332ZM41.8875 16.1971L32.2984 10.5466C32.2981 10.5464 32.2978 10.5462 32.2975 10.546C31.8211 10.2672 31.2598 10.2669 30.7804 10.5471C30.3085 10.8241 30.0332 11.3179 30.0332 11.8663V24.1195C30.0332 24.6682 30.3088 25.1622 30.7812 25.4392L30.7857 25.4418C31.0239 25.5838 31.2676 25.6446 31.5388 25.6446C31.7976 25.6446 32.0625 25.573 32.2983 25.438C32.2992 25.4375 32.3002 25.4369 32.3011 25.4364L42.6903 19.3144L42.6916 19.3136C43.1641 19.0367 43.4396 18.5427 43.4396 17.994C43.4396 17.4453 43.1641 16.9512 42.6916 16.6743L41.8839 16.2008L41.8875 16.1971ZM31.5295 11.8433C31.5262 11.8449 31.5237 11.8463 31.5223 11.8471L31.5058 11.8569C31.5057 11.8589 31.5056 11.8613 31.5056 11.8641V24.1173C31.5056 24.1197 31.5057 24.1217 31.5057 24.1235C31.5317 24.1355 31.5412 24.1378 31.5473 24.1386L31.5509 24.1375C31.5538 24.1364 31.5592 24.1342 31.5672 24.1298C31.568 24.1293 31.5688 24.1288 31.5697 24.1283L41.6044 18.2152L41.6045 18.2091L41.9622 18.0023C41.9659 18.0001 41.9687 17.9983 41.9708 17.9969L41.9714 17.9918C41.9714 17.991 41.9715 17.9905 41.9715 17.9901C41.9715 17.9902 41.9715 17.9888 41.9714 17.9873L41.9708 17.9821C41.9692 17.9811 41.9673 17.9799 41.965 17.9786L41.9572 17.9742L31.569 11.8527C31.5683 11.8523 31.5675 11.8518 31.5668 11.8514C31.5554 11.8451 31.5457 11.8415 31.5389 11.8395C31.537 11.8401 31.535 11.8409 31.5329 11.8418C31.5318 11.8423 31.5307 11.8428 31.5295 11.8433ZM30.8377 10.5798C30.976 10.4998 31.2245 10.3866 31.5409 10.3866C31.7654 10.3866 32.0149 10.4484 32.25 10.5833L32.2571 10.5873L42.6446 16.7084C42.646 16.7092 42.6475 16.7101 42.6489 16.7109C43.3209 17.098 43.3754 17.7738 43.3754 17.9896C43.3754 18.1611 43.3411 18.6088 43.0055 18.9817L43.0052 19.0606L32.2493 25.3986C31.589 25.7763 31.0213 25.4943 30.8662 25.4166C30.6019 25.2842 30.1017 24.8814 30.1017 24.1173V11.8641C30.1017 11.116 30.5807 10.7202 30.8377 10.5798ZM5.89155 27.0015C5.89155 22.041 9.85124 18.0177 14.6923 18.0177H14.6945C19.5353 18.0177 23.4953 22.0407 23.4953 27.0015V28.5028C23.4953 29.3368 22.8453 29.9803 22.0561 29.9803H7.33069C6.53685 29.9803 5.89155 29.332 5.89155 28.5028V27.0015ZM14.6923 19.4693C10.6081 19.4693 7.29543 22.8617 7.29543 27.0015V28.5028C7.29543 28.5108 7.29682 28.5145 7.29727 28.5156C7.29787 28.5171 7.29874 28.5185 7.30014 28.5199C7.30154 28.5213 7.30389 28.5232 7.30776 28.5248C7.31129 28.5263 7.31841 28.5287 7.33069 28.5287H22.0561C22.0681 28.5287 22.0752 28.5264 22.0789 28.5248C22.083 28.5231 22.0854 28.5211 22.0869 28.5197C22.0883 28.5183 22.089 28.517 22.0896 28.5157C22.0899 28.5148 22.0914 28.5112 22.0914 28.5028V27.0015C22.0914 22.8615 18.7785 19.4693 14.6945 19.4693H14.6923ZM14.6923 20.9706C11.4178 20.9706 8.7676 23.6874 8.7676 27.0017V27.0276H20.617V27.0017C20.617 23.6874 17.9668 20.9706 14.6923 20.9706ZM7.36372 27.0017C7.36372 22.8666 10.661 19.519 14.6923 19.519C18.7236 19.519 22.0209 22.8666 22.0209 27.0017V28.4792H7.36372V27.0017Z"
                  fill="white"
                />
              </svg>
            </div>
            <div class="event-detail__finish-title">
              Мероприятие закончилось
            </div>
          </div>
          <a
            target="_blank"
            class="event-detail__finish-button button button_white"
            :href="EventDetail.record_url"
            v-if="EventDetail.record_url"
          >
            Смотреть запись
          </a>
        </div>
      </div>
      <div class="event-detail__about" v-if="EventDetail.description">
        <div class="event-detail__about-title">О мероприятии</div>
        <div
          class="event-detail__about-text"
          v-html="EventDetail.description"
        ></div>
      </div>
      <div class="event-detail__program" v-if="EventDetail.programme.length">
        <div class="event-detail__program-title">Расписание</div>
        <div
          class="event-detail__program-item"
          v-for="(item, ind) in EventDetail.programme"
          :key="ind"
        >
          <input
            v-if="item.lectors.length"
            type="checkbox"
            :id="`program_${ind}`"
          />
          <label
            :style="!item.lectors.length ? `cursor: default !important;` : ``"
            :for="`program_${ind}`"
            class="event-detail__program-item-head"
          >
            <div class="event-detail__program-item-info">
              <div class="event-detail__program-item-time">
                {{ item.start }}
                –
                {{ item.end }}
              </div>
              <div
                class="event-detail__program-item-title"
                v-html="item.title"
              ></div>
            </div>
            <div
              class="event-detail__program-item-arrow"
              v-if="item.lectors.length"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.5 6.5L12 17.5L22.5 6.5"
                  stroke="black"
                  stroke-width="2"
                />
              </svg>
            </div>
          </label>
          <div class="event-detail__program-item-body">
            <div class="event-detail__program-item-body-row">
              <div class="event-detail__program-item-time">
                {{ item.start }}
                –
                {{ item.end }}
              </div>
              <div class="event-detail__program-item-lectors">
                <div
                  class="event-detail__program-item-lector"
                  v-for="(lector, ind) in item.lectors"
                  :key="ind"
                >
                  <div class="event-detail__program-item-lector-img">
                    <img v-if="lector.photo" :src="lector.photo" />
                  </div>
                  <div class="event-detail__program-item-lector-text">
                    <div class="event-detail__program-item-lector-name">
                      {{ lector.name }}
                    </div>
                    <div class="event-detail__program-item-lector-position">
                      {{ lector.position }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="event-detail__lectors" v-if="EventDetail.lectors.length">
        <div class="event-detail__lectors-head">
          <div class="event-detail__lectors-title">
            {{ EventDetail.lectors.length > 1 ? `Ведущие` : `Ведущий` }}
          </div>
          <div
            class="event-detail__lectors-arrows"
            v-show="swiper && !(swiper.isBeginning && swiper.isEnd)"
          >
            <div
              class="event-detail__lectors-arrow event-detail__lectors-arrow_prev"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 2L5 11.5L16 21"
                  stroke="currentColor"
                  stroke-width="2"
                />
              </svg>
            </div>
            <div
              class="event-detail__lectors-arrow event-detail__lectors-arrow_next"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 22L19 12.5L8 3"
                  stroke="currentColor"
                  stroke-width="2"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="event-detail__lectors-swiper-container">
          <swiper
            @swiper="setSwiper"
            class="event-detail__lectors-swiper"
            v-bind="swiperSettings"
          >
            <swiper-slide
              class="event-detail__lectors-swiper-slide"
              v-for="(lector, ind) in EventDetail.lectors"
              :key="ind"
            >
              <div class="event-detail__lectors-item">
                <div class="event-detail__lectors-item-img">
                  <img v-if="lector.photo" :src="lector.photo" />
                </div>
                <div class="event-detail__lectors-item-name">
                  {{ lector.name }}
                </div>
                <div
                  v-if="lector.position"
                  class="event-detail__lectors-item-position"
                >
                  {{ lector.position }}
                </div>
                <div v-if="lector.tag" class="event-detail__lectors-item-tag">
                  {{ lector.tag }}
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div class="event-detail__materials" v-if="EventDetail.materials.length">
        <div class="event-detail__materials-title">Полезные материалы</div>
        <div class="event-detail__materials-row">
          <div
            class="event-detail__materials-material"
            v-for="(m, ind) in EventDetail.materials"
            :key="ind"
          >
            <div
              class="event-detail__materials-material-title"
              v-html="m.title"
            ></div>
            <a
              :href="m.file || m.url"
              v-html="m.btn_text || 'Скачать'"
              target="_blank"
              download
              class="event-detail__materials-material-button button button_pink"
            >
            </a>
          </div>
        </div>
      </div>
      <div class="event-detail__shorts" v-if="EventDetail.additional_info">
        <div class="event-detail__shorts-title">Список литературы</div>
        <div
          class="event-detail__shorts-text"
          v-html="EventDetail.additional_info"
        ></div>
      </div>
    </div>
  </div>
  <div v-else-if="loaded === 404">
    <Choch class="inPage" />
  </div>
  <div v-else-if="loaded != null">
    <Error class="inPage" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Breadcrumbs from "@/components/pageComponents/Breadcrumbs.vue";
import Choch from "@/views/404.vue";
import Error from "@/views/Error.vue";
import "swiper/swiper-bundle.css";
import { Navigation } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
SwiperCore.use([Navigation]);
export default {
  metaInfo() {
    if (this.EventDetail.name) {
      return {
        title: "Az-most - " + this.EventDetail.name.replace(/<[^>]*>?/gm, ""),
      };
    } else {
      return { title: "Az-most - " + this.EventDetail.name };
    }
  },
  name: "EventDetail",
  components: { Breadcrumbs, Choch, Error, Swiper, SwiperSlide },
  data: () => ({
    loaded: null,
    subscribed: false,
    analyticInterval: null,
    is_start: "not_started",
    months: [
      "января",
      "февраля",
      "марта",
      "апреля",
      "мая",
      "июня",
      "июля",
      "августа",
      "сентября",
      "октября",
      "ноября",
      "декабря",
    ],
    timerResult: {},
    interval: null,
    swiper: null,
    swiperSettings: {
      slidesPerView: 3,
      spaceBetween: 32,
      loop: false,
      navigation: {
        nextEl: ".event-detail__lectors-arrow_next",
        prevEl: ".event-detail__lectors-arrow_prev",
        navigationDisabledClass: "swiper-navigation-disabled1",
      },
      breakpoints: {
        320: {
          slidesPerView: "auto",
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
        1220: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
    },
    socket: null,
  }),
  computed: {
    ...mapGetters(["EventDetail", "user", "IframeAccess", "isAuth"]),
    date() {
      return new Date(this.EventDetail.date);
    },
  },

  methods: {
    ...mapActions(["fetchEventDetail", "fetchIframeAccess"]),
    pageVisit(time) {
      this.$axios(`/api/analytics/send/`, {
        method: "POST",
        data: {
          brand_name: this.EventDetail.brands.map((el) => el.title).join(", "),
          brand_id: this.EventDetail.brands.map((el) => el.brand_id).join(", "),
          content_date: this.EventDetail.date,
          content_id: this.EventDetail.id,
          content_name: this.EventDetail.name.replace(/<[^>]*>?/gm, ""),
          content_type: "Мероприятие",
          nosology_name: this.EventDetail.disease
            .map((el) => el.title)
            .join(", "),
          content_parameter: "",
          event_type: "visit",
          event_duration: time,
          url: this.$root.analyticData.url,
          event_parameter: "",
          page_block: "",
          page_name: this.EventDetail.name.replace(/<[^>]*>?/gm, ""),
          page_type: "Мероприятие",
          nova_id: this.$root.analyticData.nova_id,
          session_id: this.$root.analyticData.session_id,
          user_id: this.$root.analyticData.user_id,
          browser: this.$root.analyticData.browser,
          device_type: this.$root.analyticData.device,
          dpl_id: this.$route.query.access || "",
          os: this.$root.analyticData.os,
          utm_campaign: this.$route.query.utm_campaign || "",
          utm_content: this.$route.query.utm_content || "",
          utm_medium: this.$route.query.utm_medium || "",
          utm_source: this.$route.query.utm_source || "",
          utm_term: this.$route.query.utm_term || "",
        },
      });
    },
    setSwiper(swiper) {
      this.swiper = swiper;
    },
    timer() {
      let date = new Date();
      const dateEnd = this.date.getTime();
      const diff = Math.round((dateEnd - date.getTime()) / 1000 - 600);
      if (diff <= 0) {
        if (this.EventDetail.is_start != "finished") {
          this.$set(this, "is_start", "started");
        }
        clearInterval(this.interval);
        return;
      }
      let days = Math.abs(diff) / 86400;
      let fullDays = Math.floor(days);
      let hours = (days - Math.floor(days)) * 24;
      let fullHours = Math.floor(hours);
      let minutes = (hours - Math.floor(hours)) * 60;
      let fullMinutes = Math.floor(minutes);
      let seconds = (minutes - Math.floor(minutes)) * 60;
      let fullSeconds = Math.round(seconds);
      this.$set(this, "timerResult", {});
      if (fullDays) {
        this.$set(this.timerResult, "days", fullDays);
      }
      if (fullHours) {
        this.$set(this.timerResult, "hours", fullHours);
      }
      if (fullMinutes) {
        this.$set(this.timerResult, "minutes", fullMinutes);
      }
      if (fullSeconds) {
        this.$set(this.timerResult, "seconds", fullSeconds);
      }
    },
    subscribe() {
      this.$axios(`/api/analytics/send/`, {
        method: "POST",
        data: {
          brand_name: this.EventDetail.brands.map((el) => el.title).join(", "),
          brand_id: this.EventDetail.brands.map((el) => el.brand_id).join(", "),
          content_date: this.EventDetail.date,
          content_id: this.EventDetail.id,
          content_name: this.EventDetail.name.replace(/<[^>]*>?/gm, ""),
          content_type: "Мероприятие",
          nosology_name: this.EventDetail.disease
            .map((el) => el.title)
            .join(", "),
          content_parameter: "",
          event_type: "participate",
          url: this.$root.analyticData.url,
          event_parameter: "",
          page_block: "",
          page_name: this.EventDetail.name.replace(/<[^>]*>?/gm, ""),
          page_type: "Мероприятие",
          nova_id: this.$root.analyticData.nova_id,
          session_id: this.$root.analyticData.session_id,
          user_id: this.$root.analyticData.user_id,
          browser: this.$root.analyticData.browser,
          device_type: this.$root.analyticData.device,
          dpl_id: this.$route.query.access || "",
          os: this.$root.analyticData.os,
          utm_campaign: this.$route.query.utm_campaign || "",
          utm_content: this.$route.query.utm_content || "",
          utm_medium: this.$route.query.utm_medium || "",
          utm_source: this.$route.query.utm_source || "",
          utm_term: this.$route.query.utm_term || "",
        },
      }).finally(() => {
        if (!this.isAuth) {
          let fasttrack = this.$route.query.fasttrack
            ? `&fasttrack=${this.$route.query.fasttrack}`
            : "";
          window.open(
            `${process.env.VUE_APP_SSO_HOST}signin?source=${encodeURIComponent(
              window.location.href
            )}&next_url=${
              window.location.origin
            }/az-sso&back_url=${encodeURIComponent(
              window.location.origin + this.$route.fullPath
            )}${fasttrack}`,
            "_self"
          );
          return;
        }
        this.$axios(`/api/event/${this.$route.params.id}/subscribe/`, {
          method: "POST",
        })
          .then(() => {
            this.$set(this, "subscribed", true);
          })
          .catch((e) => {});
      });
    },
    createSocket() {
      let socket = new WebSocket(
        `${
          process.env.VUE_APP_WEBSOCKET_HOST || ""
        }/ws/analytics?token=${localStorage.getItem("token")}&event_id=${
          this.EventDetail.id
        }&event_type=event_visit&session_id=${
          this.$root.analyticData.session_id
        }`
      );
      this.$set(this, "socket", socket);
      window.onbeforeunload = (e) => {
        e.returnMessage = "";
        this.socket.close();
        window.onbeforeunload = null;
      };
      socket.onopen = (e) => {
        this.socketOnOpen(e);
      };

      socket.onmessage = (e) => {
        this.socketOnMessage(e);
      };

      socket.onclose = (e) => {
        this.socketOnClose(e);
      };

      socket.onerror = (e) => {
        this.socketOnError(e);
      };
    },
    socketOnOpen(e) {
      this.socket.send(
        JSON.stringify({
          brand_name: this.EventDetail.brands.map((el) => el.title).join(", "),
          brand_id: this.EventDetail.brands.map((el) => el.brand_id).join(", "),
          content_date: this.EventDetail.date,
          content_id: this.EventDetail.id,
          content_name: this.EventDetail.name.replace(/<[^>]*>?/gm, ""),
          content_type: "Мероприятие",
          nosology_name: this.EventDetail.disease
            .map((el) => el.title)
            .join(", "),
          content_parameter: "",
          event_type: "visit",
          url: this.$root.analyticData.url,
          event_parameter: "",
          page_block: "",
          page_name: this.EventDetail.name.replace(/<[^>]*>?/gm, ""),
          page_type: "Мероприятие",
          nova_id: this.$root.analyticData.nova_id,
          session_id: this.$root.analyticData.session_id,
          user_id: this.$root.analyticData.user_id,
          browser: this.$root.analyticData.browser,
          device_type: this.$root.analyticData.device,
          dpl_id: this.$route.query.access || "",
          os: this.$root.analyticData.os,
          utm_campaign: this.$route.query.utm_campaign || "",
          utm_content: this.$route.query.utm_content || "",
          utm_medium: this.$route.query.utm_medium || "",
          utm_source: this.$route.query.utm_source || "",
          utm_term: this.$route.query.utm_term || "",
        })
      );
    },
    socketOnMessage(e) {
      const m = JSON.parse(e.data);
      if (m && m.type == "ping") {
        this.socket.send(JSON.stringify({ type: "pong" }));
      }
    },
    socketOnClose(e) {},
    socketOnError(e) {},
  },

  created() {
    this.fetchEventDetail({
      id: this.$route.params.id,
      access: this.$route.query.access || null,
    })
      .then((e) => {
        if (this.EventDetail.external) {
          return window.open(this.EventDetail.external_link, "_self");
        }
        this.$set(this, "loaded", 200);
        this.timer();
        this.interval = setInterval(this.timer, 1000);
        this.$set(this, "subscribed", this.EventDetail.subscribe);
        this.$set(this, "is_start", this.EventDetail.is_start);
        if (this.EventDetail.is_start !== "finished") {
          // this.createSocket(); // отключено для проверки лагов
        }
        this.pageVisit(0);
        let time = 0;
        this.analyticInterval = setInterval(() => {
          time++;
          if (time == 5) {
            this.pageVisit(5);
          }
          if (time == 30) {
            this.pageVisit(30);
            clearInterval(this.analyticInterval);
          }
        }, 1000);
      })
      .catch((e) => {
        this.$set(this, "loaded", e.request.status);
      });
  },
  mounted() {},
  beforeDestroy() {
    window.onbeforeunload = null;
    // this.socket.close();
    clearInterval(this.interval);
    clearInterval(this.analyticInterval);
  },
};
</script>

<style lang="scss" scoped>
.event-detail {
  &__title {
    margin-top: 32px;
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 40px;
    line-height: 53px;
    color: #000000;

    @media screen and (max-width: 767px) {
      font-size: 24px;
      line-height: 36px;
    }
  }

  &__banner {
    margin-top: 32px;
    overflow: hidden;
    border-radius: 30px;

    @media screen and (max-width: 767px) {
      border-radius: 16px;
    }

    & img {
      width: 100%;
      height: auto;
    }
  }

  &__info {
    display: flex;
    justify-content: flex-start;
    margin-top: 52px;
    border-radius: 30px;
    overflow: hidden;
    position: sticky;
    top: 10px;
    z-index: 30;
    background-color: #830051;

    @media screen and (max-width: 1220px) {
      flex-direction: column;
    }

    @media screen and (max-width: 767px) {
      margin-top: 24px;
    }
  }

  &__join {
    border-radius: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: #4f0633;
    padding: 0px 32px;

    @media screen and (max-width: 1220px) {
      padding: 24px 32px;
    }

    &-button {
      margin-left: 24px;
    }
  }

  &__props {
    gap: 50px;
    padding: 32px 40px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    @media screen and (max-width: 767px) {
      flex-direction: column;
      gap: 24px;
      margin-left: 0;
      padding: 24px 32px;
    }
  }

  &__prop {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    &:first-child {
      flex-shrink: 0;
    }

    &-icon {
      position: absolute;
      top: 0;
      left: 0;
    }

    &-text {
      margin-left: 90px;

      @media screen and (max-width: 767px) {
        margin-left: 66px;
      }
    }

    &-label {
      margin-bottom: 4px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 26px;
      color: #ffffff;
    }

    &-value {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      color: #dadada;
    }
  }

  &__timer {
    margin-left: 40px;
    padding: 32px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #fff;
    gap: 32px;

    @media screen and (max-width: 1220px) {
      flex-direction: column;
      align-items: flex-start;
    }

    @media screen and (max-width: 767px) {
      margin-left: 0;
      padding: 24px 32px;
      gap: 16px;
    }

    &-title {
      gap: 16px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 26px;
      color: #ffffff;

      & svg {
        flex-shrink: 0;
      }
    }

    &-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 8px;

      &-value {
        font-family: "Roboto Slab", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 28px;
        line-height: 47px;
        color: #ffffff;
      }

      &-text {
        font-family: "Roboto Slab", sans-serif;
        font-style: normal;
        font-weight: 300;
        font-size: 18px;
        line-height: 26px;
        color: #ffffff;

        @media screen and (max-width: 767px) {
          font-size: 0;

          &::first-letter {
            font-size: 20px;
            vertical-align: middle;
          }
        }
      }
    }

    &-row {
      gap: 24px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }

  &__watch {
    width: 100%;

    @media screen and (max-width: 767px) {
      padding: 0 32px;
    }

    &-row {
      gap: 24px;
      margin: 0 auto;
      padding: 32px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;

      @media screen and (max-width: 767px) {
        flex-direction: column;
        justify-content: flex-start;
      }
    }

    &-text {
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 26px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 24px;
    }

    &-icon {
      position: relative;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      flex-shrink: 0;
      background-color: #00a410;

      &::before,
      &::after {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        border-left: 4px solid #00a410;
        border-right: 4px solid #00a410;
        border-top: 4px solid transparent;
        border-bottom: 4px solid transparent;
        display: block;
        content: "";
      }

      &::before {
        width: 15px;
        height: 15px;
        animation: blink 0.5s linear infinite backwards alternate;
      }

      &::after {
        width: 30px;
        height: 30px;
        animation: blink 0.5s 0.25s linear infinite backwards alternate;
      }
    }

    &-button {
      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }
  }

  &__finish {
    padding: 32px 48px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 24px;

    @media screen and (max-width: 767px) {
      padding: 24px 32px;
      flex-direction: column;
    }

    &-text {
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 26px;
      color: #ffffff;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 24px;
    }

    &-button {
      margin-left: auto;

      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }
  }

  &__about {
    margin-top: 52px;
    padding: 24px 32px;
    background-color: #f8f8f8;
    border-radius: 30px;

    @media screen and (max-width: 767px) {
      margin-top: 28px;
      padding: 24px;
    }

    &-title {
      margin-bottom: 32px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 30px;
      line-height: 40px;
      color: #000000;

      @media screen and (max-width: 767px) {
        font-size: 24px;
        margin-bottom: 24px;
      }
    }

    &-text {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      color: #000000;
    }
  }

  &__program {
    margin-top: 52px;

    @media screen and (max-width: 767px) {
      margin-top: 28px;
    }

    &-title {
      margin-bottom: 40px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 30px;
      line-height: 40px;
      color: #000000;

      @media screen and (max-width: 767px) {
        font-size: 24px;
        margin-bottom: 24px;
      }
    }

    &-item {
      border-bottom: 1px solid #dadada;

      &:not(:last-child) {
        margin-bottom: 32px;
      }

      & input {
        display: none;

        &:checked {
          & ~ .event-detail__program-item-head {
            .event-detail__program-item {
              &-arrow {
                transform: rotate(180deg);
              }
            }
          }

          & ~ .event-detail__program-item-body {
            max-height: max-content;
            padding-bottom: 32px;
          }
        }
      }

      &-head {
        margin-bottom: 24px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;

        @media screen and (max-width: 767px) {
          align-items: flex-start;
        }
      }

      &-info {
        margin-right: 16px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        @media screen and (max-width: 767px) {
          flex-direction: column;
          align-items: flex-start;
        }
      }

      &-time {
        padding: 16px 24px;
        background-color: #818181;
        font-family: "Roboto Slab", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 26px;
        color: #ffffff;
        border-radius: 99px;
        margin-right: 24px;
        flex-shrink: 0;

        @media screen and (max-width: 767px) {
          padding: 8px 24px;
          margin-bottom: 16px;
          margin-right: 0;
        }
      }

      &-title {
        font-family: "Roboto Slab", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 26px;
        color: #000000;
      }

      &-arrow {
        margin-left: auto;
        transition: 0.3s;
      }

      &-body {
        max-height: 0;
        overflow: hidden;

        &-row {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
        }

        & .event-detail__program-item-time {
          opacity: 0;

          @media screen and (max-width: 767px) {
            display: none;
          }
        }
      }

      &-lector {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;

        &:not(:last-child) {
          margin-bottom: 32px;
        }

        &-img {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          overflow: hidden;
          flex-shrink: 0;
          margin-right: 16px;

          & img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
          }
        }

        &-name {
          margin-bottom: 8px;
          font-family: "Roboto Slab", sans-serif;
          font-style: normal;
          font-weight: 400;
          font-size: 20px;
          line-height: 26px;
          color: #000000;
        }

        &-position {
          font-family: "Roboto", sans-serif;
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 19px;
          color: #7b7b7b;
        }
      }
    }
  }

  &__lectors {
    margin-top: 52px;
    padding: 24px 32px;
    background-color: #f8f8f8;
    border-radius: 30px;

    @media screen and (max-width: 767px) {
      margin-top: 28px;
      padding: 24px;
    }

    &-head {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 32px;

      @media screen and (max-width: 767px) {
        margin-bottom: 24px;
      }
    }

    &-title {
      margin-right: 16px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 30px;
      line-height: 40px;
      color: #000000;

      @media screen and (max-width: 767px) {
        font-size: 24px;
      }
    }

    &-arrows {
      margin-left: auto;
      gap: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-arrow {
      width: 48px;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background-color: #d9d9d9;
      color: #fff;
      transition: 0.3s;
      cursor: pointer;

      &.swiper-button-disabled {
        pointer-events: none;
      }

      @media screen and (min-width: 1220px) {
        &:hover {
          background-color: #830051;
        }
      }
    }

    &-item {
      &-img {
        margin-bottom: 32px;
        width: 100%;
        aspect-ratio: 1/ 1;
        border-radius: 30px;
        overflow: hidden;

        & img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
      }

      &-name {
        margin-bottom: 16px;
        font-family: "Roboto Slab", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 26px;
        color: #000000;
      }

      &-position {
        margin-bottom: 16px;
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        color: #7b7b7b;
      }

      &-tag {
        width: fit-content;
        border-radius: 99px;
        padding: 4px 12px;
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        color: #ffffff;
        background-color: #0067b2;
      }
    }

    &-swiper {
      &-slide {
        @media screen and (max-width: 767px) {
          width: 70%;
        }
      }
    }
  }

  &__materials {
    margin-top: 52px;
    padding: 24px 32px;
    background-color: #f8f8f8;
    border-radius: 30px;

    @media screen and (max-width: 767px) {
      margin-top: 28px;
      padding: 24px;
    }

    &-title {
      margin-bottom: 32px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 30px;
      line-height: 40px;
      color: #000000;

      @media screen and (max-width: 767px) {
        font-size: 24px;
        margin-bottom: 24px;
      }
    }

    &-row {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 20px;

      @media screen and (max-width: 1220px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media screen and (max-width: 767px) {
        grid-template-columns: 100%;
      }
    }

    &-material {
      padding: 30px;
      height: 100%;
      background-color: #fff;
      border-radius: 30px;
      display: flex;
      flex-direction: column;

      &-title {
        margin-bottom: 24px;
        font-family: "Roboto Slab", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 26px;
        color: #000000;
      }

      &-button {
        width: 100%;
        margin-top: auto;

        @media screen and (max-width: 1220px) {
          width: fit-content;
        }
      }
    }
  }

  &__shorts {
    margin-top: 52px;

    @media screen and (max-width: 1220px) {
      margin-top: 28px;
    }

    &-title {
      margin-bottom: 32px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 30px;
      line-height: 40px;
      color: #000000;

      @media screen and (max-width: 1220px) {
        font-size: 24px;
        margin-bottom: 24px;
      }
    }

    &-text {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      color: #000000;
    }
  }
}

@keyframes blink {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>